import { render, staticRenderFns } from "./BasisEdit.vue?vue&type=template&id=72696f91&scoped=true"
import script from "./BasisEdit.vue?vue&type=script&lang=js"
export * from "./BasisEdit.vue?vue&type=script&lang=js"
import style0 from "./BasisEdit.vue?vue&type=style&index=0&id=72696f91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72696f91",
  null
  
)

export default component.exports